import { Button, FunctionCard, Heading } from '@george-labs.com/design-system';
import type { FC } from 'react';

import { t } from '@luna/i18n';

import { useProofOfAddressUpdate } from './useProofOfAddressUpdate';

export const ProofOfAddressUpdate: FC = () => {
    const { isVisible, externalApplicationUrl } = useProofOfAddressUpdate();

    const editButton = (
        <Button
            data-cy="proof-of-address-update-button"
            href={externalApplicationUrl}
            key="edit-button"
        >
            {t('main.settings.proofOfAddress.editBtn')}
        </Button>
    );

    if (!isVisible) {
        return null;
    }

    return (
        <>
            <Heading level={2}>{t('main.settings.proofOfAddress.sectionTitle')}</Heading>
            <FunctionCard
                horizontal
                data-cy="proof-of-address-update"
                heading={t('main.settings.proofOfAddress.heading')}
                headingTag="h3"
                icon={FunctionCard.ICON.FOLDER}
                buttons={[editButton]}
            >
                {t('main.settings.proofOfAddress.details')}
            </FunctionCard>
        </>
    );
};
